import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-banner-conditions',
  templateUrl: './banner-conditions-pending.component.html',
  styleUrls: ['./banner-conditions-pending.component.scss'],
})
export class BannerConditionsPendingComponent {
  @Input() title;
  @Input() description;
  @Input() iconPath;
  @Input() actionButton = false;
  @Input() buttonText;
  @Output() clickEvent = new EventEmitter();

  getDefaultIconPath(): string {
    return '../../../../../assets/icons/outline-document-text-1.svg';
  }
}
